import Wrapper from "../../Wrapper";

 const ProcessPayroll = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Process Payroll</h3>
         </Wrapper>
         </>
     );
 }
 export default ProcessPayroll;